import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import {InterfaceService} from "@app/interfaces";
import {SharedModalService} from "@app/shared-modal/service/shared-modal.service";

@Component({
    selector: 'app-activity-add-tag',
    templateUrl: './activity-add-tag.component.html',
    styleUrls: ['./activity-add-tag.component.scss']
})
export class ActivityAddTagComponent extends InterfaceService implements OnInit, OnDestroy {

    @ViewChild('dropdownWrapper') dropdownWrapper!: ElementRef;
    @ViewChild('dropdownInput') dropdownInputs!: ElementRef;
    @Input() selectedTagsList: any[] = [];
    @Input() isDropdownOnTop: boolean = false;
    @Input() activity: any;
    @Output() tagSelected = new EventEmitter<any>();
    @Output() tagRemoved = new EventEmitter<any>();
    searchText = '';
    filteredTags: any[] = [];
    isKeyboardMode: boolean = true;
    activeIndex: number = -1;
    hoveredIndex: number = -1;
    pointerInside: boolean = false;
    hashtags: any[] = [];
    activities: any [] = [];
    isDropdownOpen: boolean = false;
    loadingHashtags = true;
    private documentClickListener = this.onDocumentClick.bind(this);

    constructor(private sharedModalService: SharedModalService,) {
        super();
    }

    ngOnInit() {
        // if (this.hashtags.length === 0) {
        //     this.sharedModalService.getHashTagsList().subscribe((response: any) => {
        //         this.hashtags = response.hashtags;
        //         this.filteredTags = [...this.hashtags];
        //         this.resetDropdownState();
        //     });
        // } else {
        //     this.filteredTags = [...this.hashtags];
        //     this.resetDropdownState();
        // }
    }

    toggleDropdown() {
        this.isDropdownOpen = true;
        this.loadingHashtags = true;
        this.updateFilteredTags(true);
        document.addEventListener('click', this.documentClickListener, true);

        this.sharedModalService.getHashTagsList().subscribe(
            (response: any) => {
                this.hashtags = this.sortTags(response.hashtags || []);
                this.loadingHashtags = false;
                this.updateFilteredTags(true);
            },
            () => {
                this.loadingHashtags = false;
                this.updateFilteredTags(true);
            }
        );

        setTimeout(() => {
            if (this.dropdownInputs) {
                const inputElement = this.dropdownInputs.nativeElement;
                inputElement.focus();
            }
        }, 10);
    }

    onDocumentClick(event: Event) {
        if (!this.isDropdownOpen) return;
        const target = event.target as HTMLElement;
        if (this.dropdownWrapper && !this.dropdownWrapper.nativeElement.contains(target)) {
            this.resetDropdown();
        }
    }

    filterTags() {
        this.updateFilteredTags(true);
    }

    onKeyDown(event: KeyboardEvent) {
        const term = this.searchText.trim();
        if (!this.filteredTags.length && term === '') return;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();

            // switch to keyboard mode; start from hovered item if mouse is inside
            this.isKeyboardMode = true;
            if (this.pointerInside && this.hoveredIndex >= 0) {
                this.activeIndex = this.hoveredIndex;
                this.hoveredIndex = -1; // handover to keyboard
            }

            if (event.key === 'ArrowDown') {
                if (this.activeIndex < this.filteredTags.length - 1) this.activeIndex++;
            } else {
                if (this.activeIndex > 0) this.activeIndex--;
            }

            // keep active item visible INSIDE the dropdown
            setTimeout(() => {
                const dropdownMenu: HTMLElement = (event.target as HTMLElement)
                    .closest('.dropdown').querySelector('.dropdown-menu');

                const el: HTMLElement = dropdownMenu.querySelector(
                    `li[data-index="${this.activeIndex}"]`
                );

                if (el) {
                    el.scrollIntoView({ block: 'nearest' });
                }
            }, 0);

        } else if (event.key === 'Enter') {
            event.preventDefault();
            const indexToUse = this.isKeyboardMode ? this.activeIndex : this.hoveredIndex;
            if (indexToUse >= 0) {
                this.selectTag(this.filteredTags[indexToUse]);
            } else {
                this.onEnter();
            }
        } else if (event.key === 'Escape') {
            event.preventDefault();
            this.resetDropdown();
        }
    }

    onDropdownMouseEnter() {
        this.pointerInside = true;
    }
    onDropdownMouseLeave() {
        this.pointerInside = false;
        this.hoveredIndex = -1;
    }

    onDropdownScroll() {
        if (this.pointerInside) this.isKeyboardMode = true;
    }

    selectTag(tag: any) {
        if (!this.selectedTagsList.find(t => t.id == tag.id)) {
            this.selectedTagsList.push(tag);
            this.tagSelected.emit(tag);
        }
        this.resetDropdown();
    }

    removeTag(tag: any) {
        this.selectedTagsList = this.selectedTagsList.filter((t: any) => t.id != tag.id);
        this.tagRemoved.emit(tag);
    }

    resetDropdownState() {
        this.activeIndex = this.filteredTags.length > 0 ? 0 : -1;
        this.hoveredIndex = -1;
        this.isKeyboardMode = true;
        this.pointerInside = false;
    }

    onEnter() {
        const term = this.searchText.trim();
        if (!term) return;
        if (this.loadingHashtags) return;

        const existing = this.hashtags.find(
            tag => tag.description.toLowerCase() === term.toLowerCase()
        );

        if (existing) {
            this.selectTag(existing);
        } else {
            let tagValue = [];
            tagValue.push(term)
            const data = {activityId: this.activity ? this.activity.activityId : null, tags: tagValue};
            this.sharedModalService.saveActivityTag(data).subscribe((data:any) => {
                const tagObj = {id: data, description: term};
                this.hashtags = this.sortTags([...this.hashtags, tagObj]);
                if (!this.selectedTagsList.find(t => t.id == tagObj.id)) {
                    this.selectedTagsList.push(tagObj);
                }
                if (!this.activity && this.isDropdownOnTop) {
                    this.tagSelected.emit(tagObj);
                }
            })
        }
        this.resetDropdown();
    }

    resetDropdown() {
        this.searchText = '';
        this.filteredTags = this.sortTags(this.hashtags);
        this.isDropdownOpen = false;
        document.removeEventListener('click', this.documentClickListener, true);
    }

    private updateFilteredTags(resetState: boolean = false) {
        const term = this.searchText.trim().toLowerCase();
        const matchingTags = this.hashtags.filter((tag: any) =>
            tag.description.toLowerCase().includes(term)
        );

        this.filteredTags = this.sortTags(matchingTags, term);

        if (resetState) {
            this.resetDropdownState();
        }
    }

    private sortTags(tags: any[], term: string = '') {
        return [...tags].sort((currentTag: any, nextTag: any) => {
            const currentDescription = currentTag.description.toLowerCase();
            const nextDescription = nextTag.description.toLowerCase();
            const currentRank = this.getTagRank(currentDescription, term);
            const nextRank = this.getTagRank(nextDescription, term);

            if (currentRank !== nextRank) {
                return currentRank - nextRank;
            }

            return currentDescription.localeCompare(nextDescription);
        });
    }

    private getTagRank(description: string, term: string) {
        if (!term || description === term) {
            return 0;
        }

        if (description.startsWith(term)) {
            return 1;
        }

        return 2;
    }

    ngOnDestroy() {
        this.resetDropdownState();
        this.resetDropdown();
        document.removeEventListener('click', this.documentClickListener, true);
        this.selectedTagsList = [];
    }
}
